export const LABELS = {
  TITLE: 'Find a property',
  SUBTITLE: 'Seen a property you like? Search for the address and apply using your Sorted profile',
  BUTTON: 'Search property',
};
